module.exports = __webpack_public_path__ + "static/media/YF51_1.2f9f97ca.jpg";